import { FormControlLabel, Switch, type SwitchProps } from "@mui/material";

export interface CoAppToggleProps extends Omit<SwitchProps, "checked" | "onChange"> {
	label: string;
	checked: boolean;
	onChange: (checked: boolean) => void;
	labelPlacement?: "end" | "start" | "top" | "bottom";
}

/** Branded on/off control — uses theme `MuiSwitch` (gradient thumb when checked). */
export default function CoAppToggle({
	label,
	checked,
	onChange,
	labelPlacement = "start",
	...switchProps
}: CoAppToggleProps) {
	return (
		<FormControlLabel
			labelPlacement={labelPlacement}
			label={label}
			control={
				<Switch
					checked={checked}
					onChange={(_event, value) => onChange(value)}
					{...switchProps}
				/>
			}
			sx={{
				marginLeft: 0,
				marginRight: 0,
				width: "100%",
				justifyContent: "space-between",
				"& .MuiFormControlLabel-label": {
					fontSize: 14,
					fontWeight: 500,
					color: "rgba(13, 31, 48, 0.85)",
				},
			}}
		/>
	);
}
